import {Type, type Static} from '@sinclair/typebox';

/** Public registration, not authentication. No desktop client secret exists. */
export const DESKTOP_CLIENT_ID = 'sidetone-desktop';
export const DESKTOP_REDIRECT_URI = 'io.brandcore.sidetone://auth/callback';
export const DESKTOP_ISSUER = 'https://sidet.one';
export const DESKTOP_AUDIENCE = 'sidetone-desktop-api';
/** This one scope admits the existing API's current role/resource checks, not capture/upload. */
export const DESKTOP_SCOPE = 'sidetone.desktop';
export const DESKTOP_ACCESS_SECONDS = 300;
export const DESKTOP_FAMILY_SECONDS = 30 * 86400;
export const DesktopAuthMethodSchema = Type.Literal('desktop_pkce');
export const DesktopTokenResponseSchema = Type.Object({
  access_token: Type.String({minLength:16,maxLength:4096}),
  token_type: Type.Literal('Bearer'),
  expires_in: Type.Integer({minimum:30,maximum:86400}),
  refresh_token: Type.String({minLength:16,maxLength:4096}),
  scope: Type.Literal(DESKTOP_SCOPE),
}, {additionalProperties:false});
export type DesktopTokenResponse = Static<typeof DesktopTokenResponseSchema>;
export const DesktopOAuthErrorSchema = Type.Object({
  error: Type.String({minLength:1,maxLength:100}),
}, {additionalProperties:false});
export const DesktopConfirmationSchema = Type.Object({
  request: Type.String({pattern:'^[A-Za-z0-9_-]{43}$'}),
  decision: Type.Union([Type.Literal('allow'),Type.Literal('deny')]),
  tenant_id: Type.String({format:'uuid'}),
}, {additionalProperties:false});
export const DesktopAuthorizationViewSchema = Type.Object({
  client_id: Type.Literal(DESKTOP_CLIENT_ID),
  client_name: Type.Literal('Sidetone desktop'),
  scope: Type.Literal(DESKTOP_SCOPE),
  redirect_uri: Type.Literal(DESKTOP_REDIRECT_URI),
  tenant_id: Type.String({format:'uuid'}),
  expires_at: Type.String({format:'date-time'}),
}, {additionalProperties:false});
